export default __webpack_public_path__ + "static/media/full4.be5cddd8.png";